var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4616 9.41846L11.9099 9.41846L11.9099 1.73055L14.4617 1.73055C14.6044 1.73055 14.7414 1.79465 14.8423 1.90899C14.9433 2.0232 15 2.17818 15 2.33967L15 8.80927C15 8.97084 14.9433 9.12578 14.8423 9.24003C14.7414 9.35427 14.6044 9.41846 14.4616 9.41846Z",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9099 9.41898L9.1751 14.3656C9.06911 14.5611 8.92018 14.7222 8.74281 14.8332C8.56545 14.9443 8.36568 15.0014 8.163 14.9991C8.00336 15.0056 7.8442 14.9759 7.69491 14.9116C7.54561 14.8473 7.40922 14.7498 7.29378 14.6249C7.17835 14.5 7.08622 14.3501 7.02285 14.1842C6.95947 14.0183 6.92613 13.8397 6.9248 13.6589L6.9248 10.1135L2.19807 10.1135C2.02345 10.107 1.85197 10.0589 1.69493 9.9721C1.53789 9.88534 1.39887 9.76195 1.28698 9.61004C1.17509 9.45813 1.09293 9.28115 1.04583 9.09072C0.998731 8.9003 0.987769 8.70075 1.01371 8.5052L1.87509 2.21839C1.91177 1.88239 2.05579 1.57316 2.27979 1.34879C2.50379 1.12442 2.79258 1.00039 3.09179 1.00002L10.1549 1.00002C10.4911 0.998544 10.823 1.08611 11.1239 1.25595L11.8991 1.69449",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9099 9.41882L11.9099 1.73086",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.b50afa38821dfbd094d727a4c3d0f46d.svg";
export { ForwardRef as ReactComponent };